export const POST_TYPES = {
	ARTICLE: "ARTICLE",
	TEXT: "TEXT",
} as const
